import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=50d8f8bf&"
import script from "./Tables.vue?vue&type=script&lang=js&"
export * from "./Tables.vue?vue&type=script&lang=js&"
import style0 from "./Tables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports